export const GA4_EVENT_NAMES = {
  ECOM_INTERACTION: 'ecom_interaction',
  SELECT_ITEM: 'select_item',
  VIEW_ITEM: 'view_item',
  VIEW_ITEM_LIST: 'view_item_list',
  ADD_TO_CART: 'add_to_cart',
  VIEW_CART: 'view_cart',
  CURRENCY_CAD: 'CAD',
  MINI_CART: 'mini cart',
  CART_PAGE: 'cart page',
  QUICK_ADD: 'quick add',
  CREATE_ACCOUNT_AT_CHECKOUT: 'create_account_at_checkout',
  SIGN_IN_AT_CHECKOUT: 'sign_in_at_checkout',
  SELECT_ITEM_COOKIE: 'selectItem',
};
